const Tabby = require('tabbyjs/dist/js/tabby.min.js');
import $ from 'jquery';

if($('[data-tabs]').length) {
    const tabs = new Tabby('[data-tabs]');
}
